import { BaseMapper } from '@ps/utils';
import { UserCompanyDto } from '../dtos/user-company.dto';
import {
  UserCompanyDetail,
  UserCompanySummary,
} from '../../models/user-company.model';
import { toBuyerAccessLevel } from './access-level.parser';

export class UserCompanyMapper extends BaseMapper<
  UserCompanyDto,
  UserCompanySummary
> {
  public fromDto(dto: UserCompanyDto): UserCompanySummary {
    return {
      id: dto.id,
      name: dto.name,
      isBuyer: dto.isABuyer,
      isSupplier: dto.isASupplier,
      isOperator: dto.isAnOperator,
      isMultiBuyer: !!dto.isMultiBuyer,
    };
  }
}

export class UserCompanyDetailMapper extends BaseMapper<
  UserCompanyDto,
  UserCompanyDetail
> {
  private readonly _summaryMapper = new UserCompanyMapper();

  public fromDto(dto: UserCompanyDto): UserCompanyDetail {
    return {
      ...this._summaryMapper.fromDto(dto),
      hasApiUser: !!dto.apiUsers?.length,
      multiBuyerEntityIds: dto.multiBuyerCmps ?? [],
      multiBuyerServicePartnerIds: dto.multiBuyerServicePartnerCmps ?? [],
      multiBuyerAccessLevels: (dto.multiBuyerAccessLevels ?? []).map(
        (accessLevel) => ({
          buyerAccessLevel: toBuyerAccessLevel(accessLevel.buyerAcssLvls),
          isMultiBuyerManager: !!accessLevel.isMBManager,
        }),
      ),
    };
  }
}
